import { AqElement, openOverlay, closeOverlay, qs, qsa } from '@aq/core';

class AqHeader extends AqElement {
  init() {
    this.bar = qs('[data-bar]', this);
    this.#measure();
    this.#bindMenuDrawer();
    this.#bindSubmenus();
  }

  destroy() {
    this.resizeObserver?.disconnect();
  }

  /* The sticky bar height feeds --aq-header-h so sticky sidebars and anchors clear it. */
  #measure() {
    if (!this.bar || !('ResizeObserver' in window)) return;
    const apply = () => document.documentElement.style.setProperty('--aq-header-h', `${this.bar.offsetHeight}px`);
    this.resizeObserver = new ResizeObserver(apply);
    this.resizeObserver.observe(this.bar);
    apply();
  }

  #bindMenuDrawer() {
    const drawer = qs('[data-menu-drawer]', this);
    const toggle = qs('[data-open-menu]', this);
    if (!drawer || !toggle) return;

    this.listen(toggle, 'click', () => {
      toggle.setAttribute('aria-expanded', 'true');
      openOverlay(drawer, {
        trigger: toggle,
        onClose: () => toggle.setAttribute('aria-expanded', 'false'),
      });
    });
    this.listen(drawer, 'click', (event) => {
      if (event.target.closest('[data-close-menu]')) closeOverlay(drawer);
    });
  }

  #bindSubmenus() {
    if (this.dataset.submenus === 'none') return;
    const parents = qsa('[data-parent]', this);
    const desktop = window.matchMedia('(min-width: 900px)');
    let closeTimer;

    const set = (item, open) => {
      item.classList.toggle('is-open', open);
      qs('.aq-nav__toggle', item)?.setAttribute('aria-expanded', String(open));
    };
    const closeAll = (except) => parents.forEach((item) => item !== except && set(item, false));

    parents.forEach((item) => {
      this.listen(item, 'pointerenter', (event) => {
        if (event.pointerType !== 'mouse' || !desktop.matches) return;
        clearTimeout(closeTimer);
        closeAll(item);
        set(item, true);
      });
      this.listen(item, 'pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        closeTimer = setTimeout(() => set(item, false), 150);
      });
      this.listen(qs('.aq-nav__toggle', item), 'click', () => {
        const open = !item.classList.contains('is-open');
        closeAll(item);
        set(item, open);
      });
      this.listen(item, 'focusout', (event) => {
        if (!item.contains(event.relatedTarget)) set(item, false);
      });
    });

    this.listen(document, 'keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = parents.find((item) => item.classList.contains('is-open'));
      if (!open) return;
      set(open, false);
      qs('.aq-nav__toggle', open)?.focus();
    });
  }
}

if (!customElements.get('aq-header')) customElements.define('aq-header', AqHeader);
